var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-full text-center flex items-center",class:_vm.style,style:(_vm.color),attrs:{"alt":`Ligne ${_vm.name}`},on:{"click":function($event){return _vm.$emit('selected-click')}}},[_c('div',{staticClass:"w-full text-white"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }